export default {
  create: (client, estate_planning_order) => client.$post('estate_planning_orders', { estate_planning_order })
}